import { useQuery } from '@apollo/client';
import {
  GET_HOURLY_TRANSITION_HISTORY,
  GET_LATEST_HOURLY_TRANSITION,
} from '../graphql/hourlyTransitionOperations';

// ============================================
// TIPOS
// ============================================

export interface RemainingHourSnapshot {
  hour: number;
  posOriginalTarget: number;
  posAdaptiveTarget: number;
  posAssignedPercentage: number;
  taxOriginalTarget: number;
  taxAdaptiveTarget: number;
  taxAssignedPercentage: number;
}

export interface HourlyTransitionLog {
  id: string;
  date: string;
  completedHour: number;
  transitionTimestamp: string;

  posOriginalTarget: number;
  posAdaptiveTarget: number;
  posActualSales: number;
  posSalesCount: number;
  posOriginalPercentage: number;
  posAdaptivePercentage: number;

  taxOriginalTarget: number;
  taxAdaptiveTarget: number;
  taxActualAmount: number;
  taxSalesCount: number;
  taxOriginalPercentage: number;
  taxAdaptivePercentage: number;

  dailyPosTarget: number;
  dailyPosCumulativeSales: number;
  dailyPosOverallPercentage: number;
  dailyTaxTarget: number;
  dailyTaxCumulativeAmount: number;
  dailyTaxOverallPercentage: number;

  remainingHoursSnapshot: RemainingHourSnapshot[] | null;
  recalculationExplanation: string | null;

  systemOpinion: string | null;
  trendAssessment: string | null;
  confidenceLevel: number;
  confidenceReason: string | null;

  modStateAtTransition: boolean | null;
  autoControlEnabled: boolean | null;
  predictiveControlEnabled: boolean | null;

  createdAt: string;
}

// ============================================
// HOOKS
// ============================================

export const useHourlyTransitionHistory = (date: string, pollInterval: number = 60000) => {
  const { data, loading, error, refetch } = useQuery(GET_HOURLY_TRANSITION_HISTORY, {
    variables: { date },
    fetchPolicy: 'cache-and-network',
    pollInterval,
    skip: !date,
  });

  return {
    transitions: (data?.getHourlyTransitionHistory || []) as HourlyTransitionLog[],
    loading,
    error,
    refetch,
  };
};

export const useLatestHourlyTransition = (pollInterval: number = 60000) => {
  const { data, loading, error } = useQuery(GET_LATEST_HOURLY_TRANSITION, {
    fetchPolicy: 'network-only',
    pollInterval,
  });

  return {
    latest: data?.getLatestHourlyTransition as HourlyTransitionLog | undefined,
    loading,
    error,
  };
};
